import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

const TeaserEditModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex items-start gap-4 mb-4">
          <div className="bg-success/10 p-3 rounded-full flex-shrink-0">
            <Icon name="CheckCircle" size={24} color="var(--color-success)" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Editing Features Are Working!
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              You've successfully tested the edit functionality. To unlock full editing capabilities and access all features, please complete your payment.
            </p>
          </div>
        </div>
        
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-4">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              Redirecting you to the payment portal in a moment...
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onClose}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Continue to Payment
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TeaserEditModal;